const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = {
    xdai: {
        id: 'xdai',
        type: REFERENCE_ASSETS.XDAI,
        symbol: 'XDAI',
        decimals: 1e18,
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    },
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'wxDAI',
        decimals: 1e18,
        address: '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
    },
    usdt: {
        id: 'usdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDT',
        decimals: 1e6,
        address: '0x4ECaBa5870353805a9F068101A40E0f32ed605C6',
    },
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e6,
        address: '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
    },
    wxdai: {
        id: 'wxdai',
        type: REFERENCE_ASSETS.XDAI,
        symbol: 'WXDAI',
        decimals: 1e18,
        address: '0xe91d153e0b41518a2ce8dd3d7944fa863463a97d',
        coingeckoId: 'wrapped-xdai',
    },
    tricrv: {
        id: 'tricrv',
        coingeckoId: 'lp-3pool-curve',
        type: REFERENCE_ASSETS.USD,
        symbol: '3Crv',
        decimals: 1e18,
        address: '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        isLpToken: true,
    },
    rai: {
        id: 'rai',
        type: REFERENCE_ASSETS.OTHER,
        symbol: 'RAI',
        decimals: 1e18,
        address: '0xd7a28aa9c470e7e9d8c676bcd5dd2f40c5683afa',
        coingeckoId: 'rai',
    },
    eure: {
        id: 'eure',
        type: REFERENCE_ASSETS.EUR,
        symbol: 'EURe',
        decimals: 1e18,
        address: '0xcB444e90D8198415266c6a2724b7900fb12FC56E',
    },
    renbtc: {
        id: 'renbtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'renBTC',
        decimals: 1e18,
        address: '0x4a88248baa5b39bb4a9caa697fb7f8ae0c3f0ddb',
    },
};
